<ng-template cxOutlet="py-storefront" cxPageTemplateStyle>
  <aside>
    @defer (on immediate) {
      <cx-page-layout section="alerts"></cx-page-layout>
      <py-unsupported-message section="alerts"></py-unsupported-message>
    }
    @defer (when isUserLoggedIn$ | async) {
      <py-return-order-message></py-return-order-message>
    }
    @defer (on immediate) {
      <cx-global-message></cx-global-message>
    }
    @defer (when isUserLoggedIn$ | async) {
      <py-password-message></py-password-message>
      <py-reload-modal></py-reload-modal>
      <div class="cart-message-wrapper">
        <py-cart-message></py-cart-message>
      </div>
    }
  </aside>

  <ng-template cxOutlet="cx-header">
    <header #scrollDetectorElement>
      <div
        #headerElement
        id="header"
        class="storefront-header"
        [ngClass]="{
          'short-header': !(searchBoxVisible$ | async),
        }"
      >
        <ng-template cxOutlet="asm"></ng-template>
        <div class="header-and-customer-banner d-flex flex-column">
          @defer (when isUserLoggedIn$ | async) {
            <py-current-customer-banner></py-current-customer-banner>
          } @placeholder {
            <div #currentCustomerBannerElement id="current-customer-banner" class="current-customer-banner placeholder"></div>
          }
          <cx-page-layout section="header"></cx-page-layout>
        </div>
      </div>

      <cx-page-layout section="heroBanner"></cx-page-layout>
    </header>
  </ng-template>

  <main id="mainElement" cxSkipLink="cx-main" [cxFocus]="{ disableMouseFocus: true }">
    <router-outlet></router-outlet>
  </main>

  @defer (when hasDebugMenu$ | async) {
    <py-debug-menu *ngIf="hasDebugMenu$ | async"></py-debug-menu>
  }
  @defer (on immediate) {
    <ng-template cxOutlet="cx-footer">
      <footer class="storefront-footer">
        <py-consent-management *ngIf="isUserLoggedIn$ | async"></py-consent-management>
        <py-anonymous-consent-management *ngIf="!(isUserLoggedIn$ | async)"></py-anonymous-consent-management>
        <cx-page-layout section="uniqueSellingPointServicesFooter"></cx-page-layout>
        <cx-page-layout section="extendedFooter"></cx-page-layout>
        <cx-page-layout section="footer"></cx-page-layout>
      </footer>
    </ng-template>
  }

  <ng-container *ngIf="captchaPublicKey$ | async as publicKey">
    <div role="region" [attr.aria-label]="'common.reCaptcha_heading' | cxTranslate">
      <re-captcha
        #captchaRef="reCaptcha"
        (resolved)="reCaptchaComplete($event)"
        (error)="reCaptchaError($event)"
        errorMode="handled"
        size="invisible"
        [tabIndex]="-1"
        badge="bottomleft"
        [siteKey]="publicKey"
      >
      </re-captcha>
    </div>
  </ng-container>
</ng-template>
